export const validateLogin = (login) => (/^[\w\@\.\-]{3,100}$/.test(login));

export const validatePassword = (password) => (/^[\w\!\"\#\$\%\&\'\(\)\*\+\,\-\.\/\:\;\<\=\>\?\@\[\\\]\^\`\{\|\}\~]{6,32}/.test(password));